const flatListMaxH = { base: '700px', sm: '600px', lg: '460px' };

export const customersFlatListProps = {
  maxToRenderPerBatch: 20,
  updateCellsBatchingPeriod: 5,
  showsVerticalScrollIndicator: false,
  maxH: flatListMaxH,
  onEndReachedThreshold: 0.4,
};
